import { render, staticRenderFns } from "./CardViewList.vue?vue&type=template&id=3a8d0880&scoped=true&"
import script from "./CardViewList.vue?vue&type=script&lang=js&"
export * from "./CardViewList.vue?vue&type=script&lang=js&"
import style0 from "./CardViewList.vue?vue&type=style&index=0&id=3a8d0880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d0880",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VRow,VSkeletonLoader})
